module.exports = __webpack_public_path__ + "img/logo-beta.b269b103.svg";